import React, { useRef, useEffect } from 'react'
import HighlightText from './HighlightText'
import Award from '../elements/Award'
import MobileCarousel from './MobileCarousel'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useMedia } from 'react-use'
import AwardsHomepage from './AwardsHomepage'

window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)

const Awards = (props) => {
    const awardsRef = useRef(null)
    const handRef = useRef(null)
    const container = useRef(null)
    const trigger = useRef(null)
    const isTabletPortrait = useMedia('(min-width: 768px) and (max-width: 1024px)')

    useEffect(() => {
        if (trigger.current && handRef.current) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: trigger.current,
                    start: 'center bottom'
                }
            })
            tl.to(handRef.current, { duration: 1, y: -250, ease: 'power4.out' })
            tl.to(handRef.current, { duration: 0.6, y: -50, ease: 'power4.out' }, '-=0.2')
            tl.fromTo([...awardsRef.current.querySelectorAll('img')], { x: '-50px', opacity: 0 }, { stagger: 0.05, duration: 0.3, x: 0, opacity: 1 }, '-=0.2')
        }
    }, [])

    return (
        <div ref={container} className='awards'>
            <div className='d-none d-lg-block text-right'>
                <img src='/images/bg-awards-white.svg' alt='Exetel awards' className='main-img' />
                <div className='inner-container'>
                    <div className='text-left'>
                        <div ref={trigger} />
                        <img ref={handRef} src='/images/bg-awards-hand.svg' alt='Exetel awards' className='hand' />
                        <h1 className='m-0 mb-4'>This is going<br /><HighlightText>straight to the pool room!</HighlightText></h1>
                        <p className='m-0 sub-bold'>
                            Still unsure we are the right telco for you?<br />
                            Here at Exetel, we always strive to deliver our best.<br />
                            Here’s a few awards that we’ve picked up along the way.
                        </p>
                        <div className='award-items'>
                            <AwardsHomepage ref={awardsRef} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-lg-none'>
                <div className='d-flex px-3 px-md-5 align-items-center'>
                    <img src='/images/awards-hand-mobile.png' alt='Straight to the pool room' />
                    <div className='ml-4'>
                        <h1 className='m-0 mb-4'>
                            This is going<br />
                            <HighlightText>straight to</HighlightText><br />
                            <HighlightText>the pool room!</HighlightText>
                        </h1>
                        <p className='m-0 mb-4'>Still unsure we are the right telco for you? Here at Exetel, we always strive to deliver our best.</p>
                        <p className='m-0 bold'>Here’s a few awards that we've picked up along the way.</p>
                    </div>
                </div>
                <div className='p-3'>
                    <AwardsHomepage ref={awardsRef} />
                </div>
            </div>
        </div>
    )
}

export default Awards



// WEBPACK FOOTER //
// ./resources/js/components/Awards.js